import React, { useContext, useEffect, useRef, useState } from 'react';

import Accreditations from './Accreditations';
import Benefits from './Benefits';
import CallToAction from './CallToAction';
import Community from './Community';
import EstimateOneSplash from './EstimateOneSplash';
import GetInTouch from './GetInTouch';
import Images from './Images';
import Instagram from './Instagram';
import Jobs from './Jobs';
import JoinUs from './JoinUs';
import LatestNews from './LatestNews';
import Media from './Media';
import News from './News';
import ProjectGrid from './ProjectGrid';
import Projects from './Projects';
import Quote from './Quote';
import Quotes from './Quotes';
import RelatedPosts from './RelatedPosts';
import SiteOverview from './SiteOverview';
import Team from './Team';
import TermsText from './TermsText';
import Testimonials from './Testimonials';
import Text from './Text';
import TextImage from './TextImage';
import Video from './Video';
import WhatWeDo from './WhatWeDo';
import WhatWeOffer from './WhatWeOffer';
import WhoAreWe from './WhoAreWe';

const Content = ({ post }) => {
	
	// Ensure post.block is an array
	const blocks = Array.isArray(post.block) ? post.block : (post.block ? Object.values(post.block) : []);
	
	return (
		<>
			{blocks.map((block, i) => {
				if (block.type === 'accreditation') {
					return <Accreditations block={block} key={i} />
				} else if (block.type === 'benefits') {
					return <Benefits block={block} key={i} />
				} else if (block.type === 'community') {
					return <Community block={block} key={i} />
				} else if (block.type === 'cta') {
					return <CallToAction block={block} key={i} />
				} else if (block.type === 'estimate_one_splash') {
					return <EstimateOneSplash block={block} key={i} />
				} else if (block.type === 'get_in_touch') {
					return <GetInTouch block={block} key={i} />
				} else if (block.type === 'images') {
					return <Images block={block} key={i} />
				} else if (block.type === 'instagram') {
					return <Instagram block={block} key={i} />
				} else if (block.type === 'jobs') {
					return <Jobs block={block} key={i} />
				} else if (block.type === 'join_us') {
					return <JoinUs block={block} key={i} />
				} else if (block.type === 'latest_news') {
					return <LatestNews block={block} key={i} />
				} else if (block.type === 'media') {
					return <Media block={block} key={i} />
				} else if (block.type === 'news') {
					return <News block={block} key={i} />
				} else if (block.type === 'overview') {
					return <SiteOverview block={block} key={i} />
				} else if (block.type === 'posts') {
					return <RelatedPosts block={block} key={i} />
				} else if (block.type === 'projects') {
					return <Projects block={block} key={i} />
				} else if (block.type === 'quote') {
					return <Quote block={block} key={i} />
				} else if (block.type === 'quotes') {
					return <Quotes block={block} key={i} />
				} else if (block.type === 'selected_projects') {
					return <ProjectGrid block={block} key={i} />
				} else if (block.type === 'team') {
					return <Team block={block} key={i} />
				} else if (block.type === 'terms_text') {
					return <TermsText block={block} key={i} />
				} else if (block.type === 'testimonials') {
					return <Testimonials block={block} key={i} />
				} else if (block.type === 'text_image') {
					return <TextImage block={block} key={i} />
				} else if (block.type === 'text') {
					return <Text block={block} key={i} />
				} else if (block.type === 'video') {
					return <Video block={block} key={i} />
				} else if (block.type === 'ewhat_we_do') {
					return <WhatWeDo block={block} key={i} />
				} else if (block.type === 'what_we_offer') {
					return <WhatWeOffer block={block} key={i} />
				} else if (block.type === 'who_are_we') {
					return <WhoAreWe block={block} key={i} />
				}
				return null;
			})}
		</>
	);
};
	
export default Content;